import dayjs from 'dayjs'

import { normalizeDateString } from 'common/services/format'
import type { EncounterLabApiItem, FetchEncounterLabsResponse } from './procedure-api.type'

const toTimestamp = (docdate: string): number | null => {
  const normalized = normalizeDateString(docdate)
  return normalized ? dayjs(normalized).valueOf() : null
}

const compareLabsByDateDesc = (a: EncounterLabApiItem, b: EncounterLabApiItem): number => {
  const timeA = toTimestamp(a.docdate)
  const timeB = toTimestamp(b.docdate)
  if (timeA === null && timeB === null) return 0
  if (timeA === null) return 1
  if (timeB === null) return -1
  return timeB - timeA
}

// Newest first; labs without a usable date go last. Stable sort keeps API order for ties.
export const sortLabsByDateDesc = (labs: EncounterLabApiItem[]): EncounterLabApiItem[] =>
  [...labs].sort(compareLabsByDateDesc)

export const transformEncounterLabsResponse = (
  response: FetchEncounterLabsResponse,
): EncounterLabApiItem[] => (Array.isArray(response.data) ? sortLabsByDateDesc(response.data) : [])
